import {useApi} from "./useApi";
import {
  SearchFlightRequest,
  SearchFlightResponse,
  SearchFlightsRequest,
  SearchFlightsResponse,
} from "../types/FlightV2";


/**
 * フライト検索（往路復路どちらかのみ）
 *
 * ★レスポンスの `errors`（取得できなかった区間）と `retryAfterSec` を潰さずに返す。
 *   issue #2992 / 報告書 §8 No.4
 * @param params
 */
export const searchFlight = async (params: SearchFlightRequest) => {
  const response = await useApi.post({
    url: "/air/flight-search",
    data: params
  });

  // ★戻り値の型は SearchFlightResponse。以前は SearchFlightRequest を返す型注釈になっており、
  //   呼び出し側から errors / status を参照できなかった（issue #2992 で修正）
  return response.data as SearchFlightResponse;
}

/**
 * フライト検索（往路復路）
 *
 * ★レスポンスの `errors`（取得できなかった区間）と `retryAfterSec` を潰さずに返す。
 *   issue #2992 / 報告書 §8 No.4
 * @param params
 */
export const searchFlights = async (params: SearchFlightsRequest) => {
  const response = await useApi.post({
    url: "/air/flights-search",
    data: params
  });

  return response.data as SearchFlightsResponse;
}
